const log = config => (set, get, api) => config(args => {
    // console.log("zustand: applying", args);
    set(args);
    // console.log("zustand: newstate", get());
}, get, api);

export const middleware = fn => log(fn);
